let about1, about2, about3;

if (window.devicePixelRatio > 1) {
	about1 = require('./office_1@2x.jpg');
	about2 = require('./office_2@2x.jpg');
	about3 = require('./office_3@2x.jpg');
} else {
	about1 = require('./office_1.jpg');
	about2 = require('./office_2.jpg');
	about3 = require('./office_3.jpg');
}


export {
	about1,
	about2,
	about3
}



// WEBPACK FOOTER //
// ./src/assets/images/about/index.js